import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, IRecRepFilter, EmptyRecRepFilter } from "./Filter";
import { SubTable } from "./SubTable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { SubTableEfficiencyReport } from "../SubTableEfficiencyReport";

interface IRecruiterReport {
    login_ID?: number,
    recruiter?: string,
    branchName?: string,
    allReq?: number,
    onsite?: number,
    hybrid?: number,
    remote?: number,
    serve?: number,
    unServe?: number,
    submittal?: number,
    eci?: number,
    po?: number
}

export const RecruiterReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterReport>, loading: boolean });
    const [tFooter, setTFooter] = useState<IRecruiterReport>({});
    const [salEffFilter, setSalEffFilter] = useState<IRecRepFilter>(EmptyRecRepFilter);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [tableLoad, setTableLoad] = useState(false);
    
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    const [subTable, setSubTable] = useState({ open: false, salesID: 0, resType: 0 } as { open: boolean, salesID?: number, resType: number });
    const [subTable1, setSubTable1] = useState({ open: false, salesID: 0, resType: 0 } as { open: boolean, salesID?: number, resType: number });

    const hideSubTableDialog = () => {
        setSubTable({ open: false, salesID: 0, resType: 0 });
        setSubTable1({ open: false, salesID: 0, resType:0})
    };

    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false);
        }
    }, [salEffFilter]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Recruiter", "GET", null, `filter=${JSON.stringify(salEffFilter)}`, toast);
        if (response) {
            const data: Array<IRecruiterReport> = await response.json();

            const _data: Array<IRecruiterReport> = [];
            let totalallReq = 0;
            let totalonsite = 0;
            let totalhybrid = 0;
            let totalremote = 0;
            let totalserve = 0;
            let totalunServe = 0;
            let totalsubmittal = 0;
            let totaleci = 0;
            let totalpo = 0;
            data.forEach((d, i) => {
                if (d.allReq) totalallReq += d.allReq;
                if (d.onsite) totalonsite += d.onsite;
                if (d.hybrid) totalhybrid += d.hybrid;
                if (d.remote) totalremote += d.remote;
                if (d.serve) totalserve += d.serve;
                if (d.unServe) totalunServe += d.unServe;
                if (d.submittal) totalsubmittal += d.submittal;
                if (d.eci) totaleci += d.eci;
                if (d.po) totalpo += d.po;
                _data.push(d);
            });
            const totalRecords: IRecruiterReport = {
                recruiter: "Total Records",
                allReq: totalallReq,
                onsite: totalonsite,
                hybrid: totalhybrid,
                remote: totalremote,
                serve: totalserve,
                unServe: totalunServe,
                submittal: totalsubmittal,
                eci: totaleci,
                po: totalpo
            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        return (
            permissions.is_Export || loginObj.is_Team_Lead ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Recruiter Performance Report</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const allReq = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.allReq}</span>
    const onsite = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 2 })} className="cursor-pointer text-cyan-700 underline">{rowData.onsite}</span>
    const hybrid = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 3 })} className="cursor-pointer text-cyan-700 underline">{rowData.hybrid}</span>
    const remote = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 4 })} className="cursor-pointer text-cyan-700 underline">{rowData.remote}</span>
    const serve = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve}</span>
    const unServe = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.unServe}</span>
    const submittal = (rowData: IRecruiterReport) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 7 })} className="cursor-pointer text-cyan-700 underline">{rowData.submittal}</span>


    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Report_Recruiter/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(salEffFilter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `RecruiterReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salEffFilter={salEffFilter} setSalEffFilter={setSalEffFilter} downloadExcel={downloadExcel} excelLoading={excelLoading} onSearch={()=> setTableLoad(true)}/>
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.recruiter} />
                <Column field="recruiter" header="Recruiter" sortable body={(rowData) => <p style={{ color: rowData.user_Status ? "red" : "" }}>{rowData.recruiter}</p>} />
                <Column field="teamManager" header="Team Manager" sortable />
                <Column field="branchName" header="Rec comp(branch)" sortable    />
                <Column field="allReq" header="#AllReq" sortable body={allReq}
                footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.allReq || 0), 0);
                    return <span 
                    //onClick={() => setSubTable({ open: true,  resType: 1 }) } 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }}
                />
                <Column field="onsite" header="#Onsite" sortable body={onsite}
                footer={() => {
                    const Onsite = tableData.tableData.reduce((sum, item) => sum + (item.onsite || 0), 0);
                    return <span 
                    //onClick={() =>setSubTable1({ open: true, resType: 2 }) } 
                    className="cursor-pointer text-cyan-700 underline">{Onsite}</span>;
                }} />
                <Column field="hybrid" header="#Hybrid" sortable body={hybrid} 
                  footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.hybrid || 0), 0);
                    return <span 
                    //onClick={() => setSubTable1({ open: true, resType: 3 })} 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }} />
                <Column field="remote" header="#Remote" sortable body={remote}
                  footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.remote || 0), 0);
                    return <span 
                    //onClick={() => setSubTable1({ open: true, resType: 4 })} 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }}/>
                <Column field="serve" header="#Serve" sortable body={serve} 
                  footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.serve || 0), 0);
                    return <span 
                    //onClick={() =>setSubTable({ open: true,  resType: 5 }) } 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }} />
                <Column field="per" header="#Serve(%)" />
                <Column field="unServe" header="#UnServe" sortable body={unServe} 
                  footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.unServe || 0), 0);
                    return <span 
                    //onClick={() => setSubTable({ open: true,  resType: 6 })} 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }} />
                <Column field="submittal" header="#Submittal" sortable body={submittal} 
                  footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.submittal || 0), 0);
                    return <span 
                    //onClick={() => setSubTable1({ open: true, resType: 7 })} 
                    className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }}/>
                <Column field="eci" header="#ECI" sortable footer={tFooter.eci}
                  />
                <Column field="po" header="#PO" sortable footer={tFooter.po} />
            </DataTable>
            <SubTable open={subTable1.open} salesID={subTable1.salesID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter}/>
            <SubTableEfficiencyReport open={subTable.open} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} />
            {/* <Filter open={filter} hideDialog={hideFilterDialog} setSalEffFilter={setSalEffFilter} toast={toast} /> */}
            <Toast ref={toast} />
        </>
    );
}
